var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"white--text buttonStyle",attrs:{"color":"primary","rounded":"","disabled":_vm.disabled},on:{"click":_vm.submit}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }